export default __webpack_public_path__ + "static/media/Facebook_circle.9cc00405.svg";